import { render } from "./StudentParametersBlock.vue?vue&type=template&id=ee0cc660&scoped=true"
import script from "./StudentParametersBlock.vue?vue&type=script&lang=js"
export * from "./StudentParametersBlock.vue?vue&type=script&lang=js"

import "./StudentParametersBlock.vue?vue&type=style&index=0&id=ee0cc660&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee0cc660"]])

export default __exports__